module.exports = __webpack_public_path__ + "media/sitemap_page/images/btn_header_menu-5610d346521fc443cd30e93d37046da8.png";